import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminInbox from "@/pages/AdminInbox";
import AuthCallback from "@/pages/AuthCallback";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import SubscriptionAction from "@/pages/SubscriptionAction";

function AppRouter() {
  const location = useLocation(); // read the fragment here — window.location.hash is not reactive
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/inbox" element={<AdminInbox />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/subscribe/confirm" element={<SubscriptionAction mode="confirm" />} />
      <Route path="/unsubscribe" element={<SubscriptionAction mode="unsubscribe" />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
